import {
  ApproveRejectInvoiceLineItemDialog,
  CustomTableCell,
  CustomTableHead,
  Dialog,
  FormCheckbox,
  
  FormDatePicker,
  FormErrorLabel,
  FormFileInput,
  FormInput,
  FormLabel,
  FormMonthRangePicker,
  FormSectionHeader,
  FormSelect,
  Heading,
  Loader,
} from "@/components";
import useAddEditInvoice from "./useAddEditInvoice";
import { FormProvider } from "react-hook-form";
import {
  ALT_GL_ACCOUNT_ID,
  AMOUNT,
  APP_AMOUNT,
  APPROVED_AMOUNT,
  APPROVED_RATE_PER_UNIT,
  APPROVED_UNIT,
  ATTACHMENT,
  BASELINE_DATE,
  BLOCK,
  BLOCK_BY,
  BLOCK_DATE,
  BUDGET_MONTH,
  CHECK,
  COMMENT,
  DOC_STATUS,
  DOCUMENT_ID,
  DOCUMENT_TYPE,
  DRCR,
  drcrOptions,
  DUE_DATE,
  GL_ACCOUNT_ID,
  INVOICE_AMOUNT,
  INVOICE_DATE,
  INVOICE_NUMBER,
  INVOICE_REFERENCE,
  ITEM_TEXT,
  LINE_ITEM_TYPE,
  LINE_ITEMS,
  PARK_ITEM_ID,
  PAYMENT_BLOCK,
  PAYMENT_METHODS,
  PAYMENT_TERMS,
  POSTING_DATE,
  POSTING_MONTH,
  PROPERTY,
  RATE_PER_UNIT,
  SHORT_DESC,
  UNIT,
  VENDOR_ID,
  YEAR,
  ZONE,
} from "./consts";
import moment from "moment";
import {
  Button,
  Input,
  Label,
  Switch,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Textarea,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui";
import { Check, CircleDashed, Plus, SquarePen, Trash, X } from "lucide-react";
import { allOption, cn, formatAmount, permissionActions } from "@/lib/utils";
import { CamPaymentBlockDialog } from "./PaymentBlockDialog";
import { toast } from "@/components/Toast";

const AddInvoice = () => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    attachmentRef,
    onAddMore,
    calculateAmount,
    balanceAmount,
    vendorList,
    isVendorLoading,
    onCancel,
    commentDisabled,
    openCommentDialog,
    setOpenCommentDialog,
    onSaveComment,
    onCommentChange,
    openApprovalDialog,
    setOpenApprovalDialog,
    onApprovalConfirm,
    breadcrumbTitle,
    isDetailLoading,
    isAddPending,
    isUpdatePending,
    isDocumentTypeLoading,
    documentTypes,
    onActionClick,
    isAddSubmitForApprovalPending,
    postDocBtnDisable,
    keys,
    isAddCommentPending,
    onCommentClick,
    openViewCommentDialog,
    setOpenViewCommentDialog,
    lineItem,
    lineItemCommentText,
    allDisabled,
    invoiceId,
    openApproveRejectDialog,
    isApproved,
    isApprovePending,
    isRejectPending,
    isPostingPending,
    onApproveClick,
    onRejectClick,
    onApproveConfirm,
    onRejectConfirm,
    onClose,
    openPostDialog,
    setOpenPostDialog,
    onPostConfirmation,
    setOpenPaymentBlockDialog,
    openPaymentBlockDialog,
    onSavePaymentBlock,
    enabledApproveReject,
    enableCheckBox,
    isGLAccountLoading,
    isPaymentMethodLoading,
    isPaymentTermLoading,
    onVendorChange,
    onDeleteLineItem,
    openDeleteLineItemDialog,
    setOpenDeleteLineItemDialog,
    onDeleteLineItemConfirmation,
    confirmationText,
    isAttachmentPending,
    isDeletePending,
    isAttachmentLoading,
    invoicePermission,
    isUpdatePermission,
    isCreate,
    onBaseLineDateChanged,
    lineItems,
    isEntryView,
    setIsEntryView,
    documentId,
    glAccountList,
    isPosted,
    isLoadingZoneList,
    zoneList,
    propertyBlock,
    propertyList,
    isPropertyLoading,
    isApprovalPending,
    onReassign,
    isReassignPending,
    onZoneChange,
    onPropertyChange
  } = useAddEditInvoice();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6 !pt-0">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between sticky top-[10px] z-10 bg-g-10">
        <Heading
          title={breadcrumbTitle}
          breadcrumbData={breadcrumbData}
          showBack
          onBackClick={onBackClick}
        />
        {isPaymentMethodLoading ||
        isPaymentTermLoading ? (
          <></>
        ) : (
          <div className="grid grid-cols-1 mt-[20px] gap-[10px]">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[10px]">
              <div className="relative">
                <FormLabel>{"Payment Term"}</FormLabel>
                <Input
                  name={PAYMENT_TERMS}
                  placeholder="Please enter"
                  value={form.watch(PAYMENT_TERMS)}
                  disabled
                />
              </div>
              <div className="relative">
                <FormLabel>{"Payment Method"}</FormLabel>
                <Input
                  name={PAYMENT_METHODS}
                  placeholder="Please enter"
                  value={form.watch(PAYMENT_METHODS)}
                  disabled
                />
              </div>
              <div className="relative">
                <FormLabel>
                  {"Posting Period"}
                  <span className="text-red-700">{"*"}</span>
                </FormLabel>
                <Input
                  name={POSTING_MONTH}
                  placeholder="Please enter"
                  value={form.watch(POSTING_MONTH)}
                  disabled
                />
              </div>
              <div className="relative">
                <FormLabel>
                  {"Posting Year"}
                  <span className="text-red-700">{"*"}</span>
                </FormLabel>
                <Input
                  name={YEAR}
                  placeholder="Please enter"
                  value={form.watch(YEAR)}
                  disabled
                />
              </div>
            </div>
            <div className="flex items-center justify-center max-w-[300px]">
              Balance Amount:{"  "}
              <span
                className={cn(
                  balanceAmount == 0 ? "text-green-600" : "text-red-600",
                  "ml-2"
                )}
              >
                {formatAmount(balanceAmount, 2)}
              </span>
            </div>
          </div>
        )}
      </div>

      {isVendorLoading ||
      isDetailLoading ||
      isDocumentTypeLoading ||
      isAttachmentLoading ||
        isGLAccountLoading || isLoadingZoneList || isPropertyLoading ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[10px] rounded-lg px-[30px] py-[15px]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px] items-center">
                <FormSectionHeader>Document Header</FormSectionHeader>
                <div className="flex items-start justify-end">
                  <Button
                    variant="link"
                    type="button"
                    onClick={() => setOpenPaymentBlockDialog(true)}
                    className="pt-0 -mt-[8px]"
                    disabled={!isUpdatePermission}
                  >
                    Payment Block
                  </Button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-7 gap-[20px]">
                {documentId ? <FormInput
                  name={DOCUMENT_ID}
                  control={form.control}
                  label="Document Id"
                  placeholder="Please enter"
                  error={errors[DOCUMENT_ID]?.message}
                  isRequired={requiredFields.includes(DOCUMENT_ID)}
                  disabled
                /> : <></>}
                <FormSelect
                  key={keys.documentTypes}
                  name={DOCUMENT_TYPE}
                  control={form.control}
                  label="Document Type"
                  placeholder="Please select"
                  error={errors[DOCUMENT_TYPE]?.message}
                  isRequired={requiredFields.includes(DOCUMENT_TYPE)}
                  options={(documentTypes || [])?.map((data: any) => ({
                    value: data?.documentTypeId?.toString(),
                    label: data?.documentType,
                  }))}
                  disabled
                />
                <FormSelect
                  key={keys.vendorList}
                  name={VENDOR_ID}
                  control={form.control}
                  label="Vendor Name"
                  placeholder="Please enter"
                  error={errors[VENDOR_ID]?.message}
                  isRequired={requiredFields.includes(VENDOR_ID)}
                  options={(vendorList || [])?.map((data: any) => ({
                    value: data?.vendorId?.toString(),
                    label: data?.vendorName,
                  }))}
                  onChange={onVendorChange}
                  disabled={allDisabled || !isUpdatePermission}
                />
                <FormInput
                  name={INVOICE_NUMBER}
                  control={form.control}
                  label="Invoice Number"
                  placeholder="Please enter"
                  error={errors[INVOICE_NUMBER]?.message}
                  isRequired={requiredFields.includes(INVOICE_NUMBER)}
                  disabled={allDisabled || !isUpdatePermission}
                />
                <FormDatePicker
                  name={INVOICE_DATE}
                  control={form.control}
                  label="Invoice Date"
                  placeholder="Please select"
                  error={errors[INVOICE_DATE]?.message}
                  isRequired
                  onChange={(date: any) => {
                    form.setValue(BASELINE_DATE, date);
                    onBaseLineDateChanged();
                  }}
                  disabled={allDisabled || !isUpdatePermission}
                />
                <FormDatePicker
                  name={BASELINE_DATE}
                  control={form.control}
                  label="Baseline Date"
                  placeholder="Please select"
                  error={errors[BASELINE_DATE]?.message}
                  isRequired
                  disabled={allDisabled || !isUpdatePermission}
                  onChange={onBaseLineDateChanged}
                />
                <FormInput
                  name={INVOICE_REFERENCE}
                  control={form.control}
                  label="Invoice Reference"
                  placeholder="Please enter"
                  error={errors[INVOICE_REFERENCE]?.message}
                  isRequired={requiredFields.includes(INVOICE_REFERENCE)}
                  disabled={allDisabled || !isUpdatePermission}
                />
                <FormInput
                  name={INVOICE_AMOUNT}
                  control={form.control}
                  label="Invoice Amount"
                  placeholder="Please enter"
                  error={errors[INVOICE_AMOUNT]?.message}
                  isRequired={requiredFields.includes(INVOICE_AMOUNT)}
                  onChange={(e: any) => {
                    form.setValue(APPROVED_AMOUNT, e.target.value);
                  }}
                  disabled={allDisabled || !isUpdatePermission}
                  startIcon="$"
                  variant="float"
                  maxLength="10"
                />
                <FormInput
                  name={APPROVED_AMOUNT}
                  control={form.control}
                  label="Approved Amount"
                  placeholder="Please enter"
                  error={errors[APPROVED_AMOUNT]?.message}
                  isRequired={requiredFields.includes(APPROVED_AMOUNT)}
                  disabled={allDisabled || !isUpdatePermission}
                  startIcon="$"
                  variant="float"
                  maxLength="10"
                />
                <FormDatePicker
                  name={POSTING_DATE}
                  control={form.control}
                  label="Posting Date"
                  placeholder="Please select"
                  error={errors[POSTING_DATE]?.message}
                  isRequired
                  onChange={() => {
                    form.setValue(
                      YEAR,
                      moment(form.getValues()[POSTING_DATE]).format("YYYY")
                    );
                    form.setValue(
                      POSTING_MONTH,
                      moment(form.getValues()[POSTING_DATE]).format("MMM")
                    );
                  }}
                  disabled={allDisabled || !isUpdatePermission}
                />
                <FormDatePicker
                  name={DUE_DATE}
                  control={form.control}
                  label="Due Date"
                  placeholder="Please select"
                  error={errors[DUE_DATE]?.message}
                  isRequired={requiredFields.includes(DUE_DATE)}
                  disabled={allDisabled || !isUpdatePermission}
                />
                <FormFileInput
                  fileInputRef={attachmentRef}
                  name={ATTACHMENT}
                  control={form.control}
                  label="Attachment"
                  error={errors[ATTACHMENT]?.message}
                  isRequired={requiredFields.includes(ATTACHMENT)}
                  maxSize={5} // in MB
                  disabled={allDisabled || !isUpdatePermission}
                />
                <FormInput
                  name={COMMENT}
                  control={form.control}
                  label="Header Text"
                  placeholder="Please enter"
                  error={errors[COMMENT]?.message}
                  isRequired={requiredFields.includes(COMMENT)}
                  disabled={allDisabled || !isUpdatePermission}
                />
              </div>
            </div>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[15px]">
              <div className="grid grid-cols-1 lg:grid-cols-3 items-center justify-between">
                <FormSectionHeader className="">Line Items</FormSectionHeader>
                <div></div>
                <div
                  className={cn(
                    "grid grid-cols-1 gap-[20px] justify-end items-end",
                    enabledApproveReject ? "md:grid-cols-4" : "lg:grid-cols-3"
                  )}
                >
                  {!enabledApproveReject && <div></div>}
                  {allDisabled ? (
                    <> </>
                  ) : (
                    <Button
                      type="button"
                      disabled={!commentDisabled}
                      className="mb-5"
                      onClick={() => setOpenCommentDialog(true)}
                    >
                      Add Comment
                    </Button>
                  )}
                  {isApprovalPending ? 
                    <Button
                      type="button"
                      className="mb-5 bg-primary hover:bg-primary"
                      onClick={onReassign}
                      disabled={isReassignPending}
                    >
                      Reassign
                    </Button> : <></>}
                  {enabledApproveReject ? (
                    <>
                      <Button
                        type="button"
                        disabled={!commentDisabled}
                        className="mb-5 bg-green-600 hover:bg-green-600"
                        onClick={onApproveClick}
                      >
                        Approve
                      </Button>
                      <Button
                        type="button"
                        variant="destructive"
                        disabled={!commentDisabled}
                        className="mb-5"
                        onClick={onRejectClick}
                      >
                        Reject
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                {isPosted ? <div className="w-full flex items-center justify-end gap-2 h-[38px] mb-5">
                  <Label className="text-[10px]">GL View</Label>
                  <Switch 
                    checked={isEntryView}
                    onCheckedChange={setIsEntryView}
                  />
                  <Label className="text-[10px]">Entry View</Label>
                </div> : <></>}
              </div>

              <div className="overflow-x-auto w-full">
                <div className="min-w-[2000px]">
                  <Table>
                    <TableHeader>
                      <TableRow className="mb-3 rounded">
                        <CustomTableHead className="w-[30px]"></CustomTableHead>
                        <CustomTableHead className="w-[150px]">
                          GL Account
                        </CustomTableHead>
                        {isEntryView ? <CustomTableHead className="w-[150px]">
                          ALT. GL Account
                        </CustomTableHead> : <></>}
                        <CustomTableHead className="w-[100px]">
                          Dr/Cr
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          # Unit
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Rate Per
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Amount
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Approved # Unit
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Approved Rate Per Unit
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Approved Amount
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Budget Month & Year
                        </CustomTableHead>
                        <CustomTableHead className="w-[150px]">
                          Zone
                        </CustomTableHead>
                        <CustomTableHead className="w-[150px]">
                          Block
                        </CustomTableHead>
                        <CustomTableHead className="w-[150px]">
                          Property ID
                        </CustomTableHead>
                        <CustomTableHead className="w-[300px]">
                          Item Text
                        </CustomTableHead>
                        {invoiceId ? (
                          <CustomTableHead className="w-[150px]">
                            Approval Status
                          </CustomTableHead>
                        ) : (
                          <></>
                        )}
                        <CustomTableHead className="w-[100px]"></CustomTableHead>
                        {!allDisabled && (
                          <CustomTableHead className="w-[100px]"></CustomTableHead>
                        )}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {lineItems?.map((_: any, index: number) => {
                        const isOffset = _?.[LINE_ITEM_TYPE]?.toLowerCase() == "offset";
                        if (isOffset && isEntryView) return;

                        return (
                          <TableRow
                            key={`row-${index}`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            <CustomTableCell>
                              <FormCheckbox
                                name={`${LINE_ITEMS}.${index}.${CHECK}`}
                                control={form.control}
                                label=""
                                placeholder=""
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    CHECK
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${CHECK}`
                                )}
                                disabled={enableCheckBox(_)}
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormSelect
                                key={keys.glMasterListing}
                                name={`${LINE_ITEMS}.${index}.${GL_ACCOUNT_ID}`}
                                control={form.control}
                                label=""
                                placeholder="Select"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    GL_ACCOUNT_ID
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${GL_ACCOUNT_ID}`
                                )}
                                options={
                                  glAccountList?.map((data: any) => {
                                    return {
                                      label: `${data?.glAccountNumber} - ${data?.accountShortDesc}`,
                                      value: data?.glMasterId?.toString(),
                                    };
                                  })}
                                  onChange={(value: any) => {
                                    const altNo = glAccountList
                                    ?.find(
                                      (data: any) =>
                                        data?.glMasterId?.toString() ===
                                        value?.toString()
                                    )
                                    ?.alternativeAccount?.toString()
                                    form.setValue(
                                      `${LINE_ITEMS}.${index}.${ALT_GL_ACCOUNT_ID}`,
                                      altNo?.toString() || ""
                                    )
                                  }}
                                disabled={allDisabled || isOffset}
                              />
                            </CustomTableCell>
                            {isEntryView ? <CustomTableCell>
                              <FormInput
                                name={`${LINE_ITEMS}.${index}.${ALT_GL_ACCOUNT_ID}`}
                                control={form.control}
                                label=""
                                placeholder="Enter"
                                disabled
                              />
                            </CustomTableCell> : <></>}
                            <CustomTableCell>
                              <FormSelect
                                key={keys.drcr}
                                name={`${LINE_ITEMS}.${index}.${DRCR}`}
                                control={form.control}
                                label=""
                                placeholder="Select"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    DRCR
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${DRCR}`
                                )}
                                options={drcrOptions}
                                disabled={allDisabled || !isUpdatePermission}
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormInput
                                name={`${LINE_ITEMS}.${index}.${UNIT}`}
                                control={form.control}
                                label=""
                                placeholder="Enter"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    UNIT
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${UNIT}`
                                )}
                                variant="integer"
                                onChange={(e: any) => {
                                  calculateAmount(
                                    e.target.value,
                                    form.watch(
                                      `${LINE_ITEMS}.${index}.${RATE_PER_UNIT}`
                                    ),
                                    `${LINE_ITEMS}.${index}.${AMOUNT}`
                                  );
                                  calculateAmount(
                                    e.target.value,
                                    form.watch(
                                      `${LINE_ITEMS}.${index}.${RATE_PER_UNIT}`
                                    ),
                                    `${LINE_ITEMS}.${index}.${APP_AMOUNT}`
                                  );
                                  form.setValue(
                                    `${LINE_ITEMS}.${index}.${APPROVED_UNIT}`,
                                    e.target.value
                                  );
                                }}
                                disabled={allDisabled || !isUpdatePermission}
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormInput
                                name={`${LINE_ITEMS}.${index}.${RATE_PER_UNIT}`}
                                control={form.control}
                                label=""
                                placeholder="Enter"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    RATE_PER_UNIT
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${RATE_PER_UNIT}`
                                )}
                                variant="float"
                                onChange={(e: any) => {
                                  calculateAmount(
                                    form.watch(
                                      `${LINE_ITEMS}.${index}.${UNIT}`
                                    ),
                                    e.target.value,
                                    `${LINE_ITEMS}.${index}.${AMOUNT}`
                                  );
                                  calculateAmount(
                                    form.watch(
                                      `${LINE_ITEMS}.${index}.${UNIT}`
                                    ),
                                    e.target.value,
                                    `${LINE_ITEMS}.${index}.${APP_AMOUNT}`
                                  );
                                  form.setValue(
                                    `${LINE_ITEMS}.${index}.${APPROVED_RATE_PER_UNIT}`,
                                    e.target.value
                                  );
                                }}
                                disabled={allDisabled || !isUpdatePermission}
                                startIcon="$"
                                maxLength="10"
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormInput
                                name={`${LINE_ITEMS}.${index}.${AMOUNT}`}
                                control={form.control}
                                label=""
                                placeholder="Enter"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    AMOUNT
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${AMOUNT}`
                                )}
                                variant="float"
                                disabled
                                startIcon="$"
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormInput
                                name={`${LINE_ITEMS}.${index}.${APPROVED_UNIT}`}
                                control={form.control}
                                label=""
                                placeholder="Enter"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    APPROVED_UNIT
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${APPROVED_UNIT}`
                                )}
                                variant="integer"
                                onChange={(e: any) => {
                                  calculateAmount(
                                    e.target.value,
                                    form.watch(
                                      `${LINE_ITEMS}.${index}.${APPROVED_RATE_PER_UNIT}`
                                    ),
                                    `${LINE_ITEMS}.${index}.${APP_AMOUNT}`
                                  );
                                }}
                                disabled={allDisabled || !isUpdatePermission}
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormInput
                                name={`${LINE_ITEMS}.${index}.${APPROVED_RATE_PER_UNIT}`}
                                control={form.control}
                                label=""
                                placeholder="Enter"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    APPROVED_RATE_PER_UNIT
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${APPROVED_RATE_PER_UNIT}`
                                )}
                                variant="float"
                                onChange={(e: any) => {
                                  calculateAmount(
                                    form.watch(
                                      `${LINE_ITEMS}.${index}.${APPROVED_UNIT}`
                                    ),
                                    e.target.value,
                                    `${LINE_ITEMS}.${index}.${APP_AMOUNT}`
                                  );

                                  const gl = glAccountList?.find(
                                    (gl: any) =>
                                      form.watch(
                                        `${LINE_ITEMS}.${index}.${GL_ACCOUNT_ID}`
                                      ) == gl.glMasterId
                                  );

                                  if (
                                    gl?.budgetTransactionRate < e.target.value
                                  ) {
                                    toast.warning(
                                      `The rate for GL ${gl?.glAccountNumber} exceeds the rate defined ($${gl?.budgetTransactionRate}) in the budget.`
                                    );
                                  }
                                }}
                                disabled={allDisabled || !isUpdatePermission}
                                startIcon="$"
                                maxLength="10"
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormInput
                                name={`${LINE_ITEMS}.${index}.${APP_AMOUNT}`}
                                control={form.control}
                                label=""
                                placeholder="Enter"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    APP_AMOUNT
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${APP_AMOUNT}`
                                )}
                                variant="float"
                                disabled
                                startIcon="$"
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormMonthRangePicker
                                name={`${LINE_ITEMS}.${index}.${BUDGET_MONTH}`}
                                control={form.control}
                                label=""
                                placeholder="Select"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    BUDGET_MONTH
                                  ]?.message
                                }
                                isRequired={form.watch(
                                  `${LINE_ITEMS}.${index}.${BUDGET_MONTH}`
                                )}
                                onClear={() =>
                                  form.setValue(
                                    `${LINE_ITEMS}.${index}.${BUDGET_MONTH}`,
                                    ""
                                  )
                                }
                                disabled={allDisabled || !isUpdatePermission}
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormSelect
                                key={keys.zone}
                                name={`${LINE_ITEMS}.${index}.${ZONE}`}
                                control={form.control}
                                label=""
                                placeholder="Please select"
                                error={(errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                  ZONE
                                ]?.message}
                                isRequired={requiredFields.includes(`${LINE_ITEMS}.${index}.${ZONE}`)}
                                onChange={(value: string) => onZoneChange(value, index)}
                                options={[...allOption, ...(zoneList?.data || [])
                                  ?.map((data: any) => ({
                                    value: data?.id?.toString(),
                                    label: data?.name,
                                  }))
                                  ?.filter((data: any) => data?.value && data?.label)]}
                                disabled={allDisabled || isOffset}
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormSelect
                                key={keys.block}
                                name={`${LINE_ITEMS}.${index}.${BLOCK}`}
                                control={form.control}
                                label=""
                                placeholder="Please select"
                                error={(errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                  BLOCK
                                ]?.message}
                                isRequired={requiredFields.includes(`${LINE_ITEMS}.${index}.${BLOCK}`)}
                                options={[...allOption, ...(propertyBlock?.data || [])
                                  ?.map((data: any) => ({
                                    value: data?.id?.toString(),
                                    label: data?.name,
                                  }))
                                  ?.filter((data: any) => data?.value && data?.label)]}
                                disabled={allDisabled || isOffset}
                              />
                            </CustomTableCell>
                            <CustomTableCell>
                              <FormSelect
                                key={keys.property}
                                name={`${LINE_ITEMS}.${index}.${PROPERTY}`}
                                control={form.control}
                                label=""
                                placeholder="Please select"
                                error={(errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                  PROPERTY
                                ]?.message}
                                isRequired={requiredFields.includes(`${LINE_ITEMS}.${index}.${PROPERTY}`)}
                                onChange={(value: string) => onPropertyChange(value, index)}
                                options={[...allOption, ...(propertyList?.data || [])
                                  ?.filter((data: any) => form.watch(`${LINE_ITEMS}.${index}.${BLOCK}`) == "all" || data.blockId?.toString() == form.watch(`${LINE_ITEMS}.${index}.${BLOCK}`))
                                  ?.map((data: any) => ({
                                  value: data?.propertyId?.toString(),
                                  label: `${data?.displayId || data?.propertyId || ""} (${data?.name || ""})`,
                                }))]}
                                disabled={allDisabled || isOffset}
                              />
                            </CustomTableCell>
                            <CustomTableCell className="w-[300px]">
                              <FormInput
                                name={`${LINE_ITEMS}.${index}.${ITEM_TEXT}`}
                                control={form.control}
                                label=""
                                placeholder="Enter"
                                error={
                                  (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                    ITEM_TEXT
                                  ]?.message
                                }
                                isRequired={requiredFields.includes(
                                  `${LINE_ITEMS}.${index}.${ITEM_TEXT}`
                                )}
                                disabled={allDisabled || !isUpdatePermission}
                              />
                            </CustomTableCell>
                            {invoiceId ? (
                              <CustomTableCell>
                                {_.approvalStatus?.toLowerCase() == "draft" ? (
                                  <SquarePen className="h-[20px] w-[20px]" />
                                ) : (
                                  <TooltipProvider>
                                    <Tooltip>
                                      <TooltipTrigger
                                        className="mx-1"
                                        type="button"
                                      >
                                        <div className="flex items-center justify-center">
                                          {_.approvalStatus?.toLowerCase() ==
                                          "approved" ? (
                                            <Check className="h-[20px] w-[20px] stroke-green-600" />
                                          ) : _.approvalStatus?.toLowerCase() ==
                                            "pending_approval" ? (
                                            <CircleDashed className="h-[20px] w-[20px] stroke-yellow-600" />
                                          ) : _.approvalStatus?.toLowerCase() ==
                                            "rejected" ? (
                                            <X className="h-[20px] w-[20px] stroke-red-600" />
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </TooltipTrigger>
                                      <TooltipContent>
                                        {_?.approvalType?.toLowerCase() ==
                                        "auto_approve" ? (
                                          <div className="grid grid-cols-1 gap-[5px] mt-[10px]">
                                            <span>Approved By System</span>
                                          </div>
                                        ) : (
                                          _?.approvers?.map(
                                            (data: any, index: number) => {
                                              return (
                                                <>
                                                  {!["approved", "posted"].includes(
                                                    String(form.watch(DOC_STATUS) || "").toLowerCase()
                                                  ) &&
                                                  data?.approvalStatus?.toLowerCase() ==
                                                    "pending_approval" ? (
                                                    <div className="grid grid-cols-1 gap-[5px] mt-[10px]">
                                                      <span>
                                                        Approval Status:
                                                        {" Pending"} <br />
                                                      </span>
                                                      <span>
                                                        Approval Type:{" "}
                                                        {data?.approvalType}
                                                      </span>
                                                      {data?.approvalType !==
                                                        "CAM" && (
                                                        <span>
                                                          Position:{" "}
                                                          {
                                                            data?.bomPositionName
                                                          }
                                                        </span>
                                                      )}
                                                    </div>
                                                  ) : data.approvalStatus?.toLowerCase() ==
                                                    "rejected" ? (
                                                    <div className="grid grid-cols-1 gap-[5px] mt-[10px]">
                                                      <span>
                                                        Rejected By:{" "}
                                                        {data?.userName || "-"}{" "}
                                                        <br />
                                                      </span>
                                                      <span>
                                                        Rejected On:{" "}
                                                        {data?.updatedAt
                                                          ? moment(
                                                              data?.updatedAt
                                                            ).format(
                                                              "MM/DD/YYYY"
                                                            )
                                                          : "-"}
                                                      </span>
                                                    </div>
                                                  ) : data?.approvalStatus?.toLowerCase() ==
                                                    "pending_approval" ? (
                                                    <></>
                                                  ) : (
                                                    <div className="grid grid-cols-1 gap-[5px] mt-[10px]">
                                                      <span>
                                                        Approved By:{" "}
                                                        {data?.userName || "-"}{" "}
                                                        <br />
                                                      </span>
                                                      <span>
                                                        Approved On:{" "}
                                                        {data?.updatedAt
                                                          ? moment(
                                                              data?.updatedAt
                                                            ).format(
                                                              "MM/DD/YYYY"
                                                            )
                                                          : "-"}
                                                      </span>
                                                    </div>
                                                  )}
                                                  {_?.approvers?.length - 1 !=
                                                  index ? (
                                                    <hr />
                                                  ) : (
                                                    <></>
                                                  )}
                                                </>
                                              );
                                            }
                                          )
                                        )}
                                      </TooltipContent>
                                    </Tooltip>
                                  </TooltipProvider>
                                )}
                              </CustomTableCell>
                            ) : (
                              <></>
                            )}
                            <CustomTableCell>
                              <Button
                                variant="link"
                                type="button"
                                onClick={() => onCommentClick(_)}
                              >
                                Comment
                              </Button>
                            </CustomTableCell>
                            {!allDisabled && index != 0 && (
                              <CustomTableCell>
                                <Button
                                  onClick={() => onDeleteLineItem(index)}
                                  disabled={!isUpdatePermission}
                                >
                                  <Trash />
                                </Button>
                              </CustomTableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </div>
              <div className="mb-3">
                <FormErrorLabel className="relative">
                  {(errors as any)?.[BUDGET_MONTH]?.message || ""}
                </FormErrorLabel>
              </div>
              {allDisabled ? (
                <></>
              ) : (
                <Button
                  variant="link"
                  onClick={onAddMore}
                  type="button"
                  disabled={!isUpdatePermission}
                >
                  <Plus className="h-4 w-4" /> Add More
                </Button>
              )}
            </div>
            <div className="flex flex-col md:flex-row justify-end gap-3  py-3">
              <Button variant="outline" type="button" onClick={onCancel}>
                Cancel
              </Button>
              {!allDisabled ? (
                <>
                  {isCreate || isUpdatePermission ? (
                    <Button
                      type="submit"
                      disabled={
                        isAddPending ||
                        isUpdatePending ||
                        isAddSubmitForApprovalPending ||
                        isAddCommentPending ||
                        isPostingPending ||
                        isAttachmentPending ||
                        isDeletePending
                      }
                      onClick={() => onActionClick(1)}
                    >
                      {isAddPending ||
                      isUpdatePending ||
                      isAddCommentPending ||
                      isAttachmentPending ||
                      isDeletePending ? (
                        <Loader variant="secondary" />
                      ) : (
                        <></>
                      )}
                      Park
                    </Button>
                  ) : (
                    <></>
                  )}
                  {invoicePermission[permissionActions.SUBMIT] ? (
                    <Button
                      type="button"
                      onClick={() => {
                        setOpenApprovalDialog(true);
                        onActionClick(2);
                      }}
                      disabled={
                        isAddPending ||
                        isUpdatePending ||
                        isAddSubmitForApprovalPending ||
                        isAddCommentPending ||
                        isPostingPending ||
                        isAttachmentPending ||
                        isDeletePending
                      }
                    >
                      {isAddSubmitForApprovalPending || isAddCommentPending ? (
                        <Loader variant="secondary" />
                      ) : (
                        <></>
                      )}{" "}
                      Submit For Approval
                    </Button>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}

              {postDocBtnDisable &&
                invoicePermission[permissionActions.POST] && (
                  <Button
                    type="button"
                    disabled={isPostingPending}
                    onClick={() => {
                      setOpenPostDialog(true);
                      onActionClick(3);
                    }}
                  >
                    {isPostingPending ? <Loader variant="secondary" /> : <></>}{" "}
                    Post the Document
                  </Button>
                )}
            </div>
          </form>
        </FormProvider>
      )}

      {openCommentDialog && (
        <Dialog
          open={openCommentDialog}
          setOpen={setOpenCommentDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Add Comment"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
          onSave={onSaveComment}
        >
          <div className="relative">
            <FormLabel>Comment</FormLabel>
            <Textarea placeholder="Please enter" onChange={onCommentChange} />
          </div>
        </Dialog>
      )}

      {openViewCommentDialog && (
        <Dialog
          open={openViewCommentDialog}
          setOpen={setOpenViewCommentDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {lineItem?.[PARK_ITEM_ID] && lineItem?.[SHORT_DESC]
                ? `${lineItem?.[PARK_ITEM_ID]} - ${lineItem?.[SHORT_DESC]} Comments`
                : "Comments"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
        >
          <div className="relative">
            <ul>
              {lineItemCommentText?.data?.length
                ? lineItemCommentText?.data?.map((data: any, index: number) => (
                    <li>
                      {index + 1}. {data?.comment}
                    </li>
                  ))
                : "Comments Not Found"}
            </ul>
          </div>
        </Dialog>
      )}

      {openApprovalDialog && (
        <Dialog
          open={openApprovalDialog}
          setOpen={setOpenApprovalDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Confirmation"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
          cancelText="No"
          saveText="Yes"
          onSave={onApprovalConfirm}
        >
          <p className="text-sm">
            Do you want to send this invoice for approval?
          </p>
        </Dialog>
      )}

      {openPostDialog && (
        <Dialog
          open={openPostDialog}
          setOpen={setOpenPostDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Confirmation"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
          cancelText="No"
          saveText="Yes"
          onSave={onPostConfirmation}
        >
          <p className="text-sm">Do you want to post this invoice?</p>
        </Dialog>
      )}

      {openPaymentBlockDialog && (
        <CamPaymentBlockDialog
          allDisabled={allDisabled}
          open={openPaymentBlockDialog}
          setOpen={setOpenPaymentBlockDialog}
          defaultValues={{
            [PAYMENT_BLOCK]: form.watch(PAYMENT_BLOCK),
            [BLOCK_DATE]: form.watch(BLOCK_DATE),
            [BLOCK_BY]: form.watch(BLOCK_BY),
          }}
          onSavePaymentBlock={onSavePaymentBlock}
        />
      )}

      {openApproveRejectDialog && (
        <ApproveRejectInvoiceLineItemDialog
          open={openApproveRejectDialog}
          onClose={onClose}
          onConfirm={isApproved ? onApproveConfirm : onRejectConfirm}
          isLoading={isApprovePending || isRejectPending}
          isApproved={isApproved}
          text={confirmationText()}
        />
      )}

      {openDeleteLineItemDialog && (
        <Dialog
          open={openDeleteLineItemDialog}
          setOpen={setOpenDeleteLineItemDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Confirmation"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
          cancelText="No"
          saveText="Yes"
          onSave={onDeleteLineItemConfirmation}
        >
          <p className="text-sm">Do you want to delete the line item?</p>
        </Dialog>
      )}
    </div>
  );
};

export default AddInvoice;
